require('./impositionsTable.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { FormattedText, getLanguage } = require('core/i18n').i18n;
// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const ImpositionRow = require('components/deposits/impositionsTable/impositionsRow');
const { COUNTRIES_CODES: { NL, PT, ES, DE } } = require('constants/countries');
class ImpositionsTable extends React.Component {

    buildColumnTitles({ hasControlActionButtonOverflow }) {
        const { isClosed, originCountry } = this.props;
        let interesCell;
        if (!isClosed) {
            if ([NL, PT, ES, DE].includes(originCountry)){
                interesCell = (
                    <OKTableCell asHeader={true} className="imposition-table__tae">
                        <FormattedText value="impositionRow-tin" /> 
                    </OKTableCell>
                );
            }else{
                interesCell = (
                    <OKTableCell asHeader={true} className="imposition-table__tae">
                        <FormattedText value="impositionRow-tae" />
                    </OKTableCell>
                );
            }
        }

        return (
            <OKTableRow asHeader={true} className="imposition-table">
                <OKTableCell asHeader={true} className="imposition-table__date">
                    <FormattedText value="impositionRow-expirationDate" />
                </OKTableCell>
                <OKTableCell asHeader={true} className="imposition-table__status">
                    <FormattedText value="impositionRow-status" />
                </OKTableCell>
                <OKTableCell asHeader={true} className="imposition-table__contract">
                    <FormattedText value="impositionRow-contractId" />
                </OKTableCell>
                {interesCell}
                <OKTableCell asHeader={true} className="imposition-table__amount">
                    <FormattedText value="impositionRow-amount" />
                </OKTableCell>
                {
                    !hasControlActionButtonOverflow && (
                        <OKTableCell asHeader={true} className="imposition-table__right-action" />
                    )
                }
            </OKTableRow>
        );
    }

    buildTableContent({ hasControlActionButtonOverflow }) {
        const { immDeposit, actualDate, isClosed, originCountry } = this.props;
        const immImpositions = immDeposit.get('impositionList');
        const depositId = immDeposit.get('id');
        const immImpositionsByOrder = immImpositions.get('byOrder');

        if (immImpositionsByOrder.size) {
            return immImpositionsByOrder.map((impositionId, index) => {
                const imposition = immImpositions.getIn(['byId', impositionId]);
                const impId = imposition.get('id');
                const url = `/myprofile/deposits/${depositId}/imposition/${impId}`;
                return (
                    <ImpositionRow
                        isClosed={isClosed}
                        key={index}
                        expirationDate={imposition.get('expirationDate')}
                        actualDate={actualDate}
                        id={impId}
                        tae={imposition.get('tae')}
                        tin={imposition.get('tin')}
                        amount={imposition.get('amount')}
                        currency={imposition.get('currency')}
                        originCountry={originCountry}
                        url={url}
                        hasControlActionButtonOverflow={hasControlActionButtonOverflow}
                    />
                );
            });
        }
    }

    render() {
        const hasControlActionButtonOverflow = [NL, DE].includes(getLanguage().toLocaleUpperCase())
        const columnTitles = this.buildColumnTitles({ hasControlActionButtonOverflow });
        const tableContent = this.buildTableContent({ hasControlActionButtonOverflow });

        return (
            <OKTable>
                <thead>
                    {columnTitles}
                </thead>
                <tbody className='imposition-table__body'>
                    {tableContent}
                </tbody>
            </OKTable>
        );
    }
}

ImpositionsTable.propTypes = {
    immDeposit: PropTypes.object.isRequired,
    actualDate: PropTypes.string.isRequired,
    isClosed: PropTypes.bool,
    originCountry: PropTypes.string.isRequired,
};

module.exports = ImpositionsTable;